import { style } from '@vanilla-extract/css';

import { column } from '../columns/Column.css';
import { documentContainer } from '../document/Document.css';
import { section } from '../section/Section.css';

export const numberedListContainer = style({
  selectors: {
    [`${documentContainer} > &, ${section} > &, ${column} > &`]: {
      paddingLeft: 'calc(var(--wt-padding, 10px) + var(--wt-list-padding-left, 27px))',
      paddingRight: 'calc(var(--wt-padding, 10px) + var(--wt-list-padding-right, 17px))',
      paddingTop: 'var(--wt-list-padding-top, 12px)',
      paddingBottom: 'var(--wt-list-padding-bottom, 12px)',
    },
  },
});

export const numberedList = style({
  listStyleType: 'var(--wt-ordered-list-style-type, decimal)',
  color:
    'var(--post-section-text-color, var(--site-theme-text-on-background-color, var(--wt-list-font-color, #000000)))',
  margin: '0px 0px 0px 25px',
  padding: '0',
  fontSize: 'var(--wt-list-font-size, 16px)',
  fontFamily: 'var(--wt-list-font-family, Arial)',
  fontWeight: 'var(--wt-list-font-weight, normal)',
  lineHeight: 'var(--wt-list-line-height-size, 1.5)',
  selectors: {
    '& &': {
      listStyleType: 'var(--wt-ordered-list-style-type, lower-alpha)',
    },
    '& & &': {
      listStyleType: 'var(--wt-ordered-list-style-type, lower-roman)',
    },
  },
});
